import app, { auth } from "../../firebase";

function getAnalyticsFunctionsBaseUrl() {
  const configuredBaseUrl = process.env.REACT_APP_ANALYTICS_FUNCTIONS_BASE_URL;
  if (configuredBaseUrl) return configuredBaseUrl.replace(/\/$/, "");

  const projectId = app?.options?.projectId || process.env.REACT_APP_FIREBASE_PROJECT_ID;
  return `https://us-central1-${projectId}.cloudfunctions.net`;
}

function normalizeApiError(error) {
  return {
    code: error?.code || "unknown",
    message: error?.message || "Analytics could not be loaded. Refresh and try again.",
  };
}

async function postAnalyticsAdmin(endpoint, pageId) {
  const user = auth.currentUser;
  if (!user) {
    throw { code: "unauthenticated", message: "Authentication is required to view analytics." };
  }

  const token = await user.getIdToken();
  const response = await fetch(`${getAnalyticsFunctionsBaseUrl()}/${endpoint}`, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ pageId }),
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw {
      code: payload?.code || `http-${response.status}`,
      message: payload?.message || "Analytics could not be loaded. Refresh and try again.",
    };
  }

  return payload;
}

export async function fetchVideoAnalytics(pageId) {
  try {
    return await postAnalyticsAdmin("getVideoAnalytics", pageId);
  } catch (error) {
    throw normalizeApiError(error);
  }
}

export async function exportVideoAnalyticsCsv(pageId) {
  try {
    return await postAnalyticsAdmin("exportVideoAnalyticsCsv", pageId);
  } catch (error) {
    throw normalizeApiError(error);
  }
}

export async function exportVideoAnalyticsReport(pageId) {
  try {
    return await postAnalyticsAdmin("exportVideoAnalyticsReport", pageId);
  } catch (error) {
    throw normalizeApiError(error);
  }
}

export { getAnalyticsFunctionsBaseUrl, postAnalyticsAdmin };
